import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const url = process.env.REACT_APP_BACKEND_URL;

const refreshAccessToken = async (): Promise<boolean> => {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return false;

  try {
    const response = await fetch(`${url}token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    const data = await response.json();
    if (!response.ok) return false;

    localStorage.setItem("access_token", data.access);
    return true;
  } catch {
    return false;
  }
};

const ProtectedRoute: React.FC = () => {
  const [isValid, setIsValid] = useState<boolean | null>(null);

  useEffect(() => {
    const validateToken = async () => {
      const accessToken = localStorage.getItem("access_token");
      if (!accessToken) {
        setIsValid(false);
        return;
      }

      try {
        const payload = JSON.parse(atob(accessToken.split(".")[1]));
        const now = Math.floor(Date.now() / 1000);

        if (payload.exp < now) {
          const refreshed = await refreshAccessToken();
          setIsValid(refreshed);
        } else {
          setIsValid(true);
        }
      } catch {
        setIsValid(false);
      }
    };

    validateToken();
  }, []);

  if (isValid === null) return <div></div>;

  if (!isValid) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    return <Navigate to="/timeout" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
